import ComponentsTop from "./ComponentsTop";
import ComponentsBottom from "./ComponentsBottom";

import Auth from "../utils/auth";
import Bus from "../utils/EventBus";

export default {
	name: 'Layout',
	components: {
		ComponentsTop,
		ComponentsBottom
	},
	data(){
		return{
			ShowTopArrow:false,

			IsScrollBottom:false,

		}
	},
	methods:{
		HandleScroll(event) {
			let ScrollTop = event.scrollTop;

			//超出范围显示返回顶部箭头
			if(ScrollTop >= 100){
				this.ShowTopArrow = true;
			}else{
				this.ShowTopArrow = false;
			}

			//判断是否触底
			const ScrollBar = this.$refs.ScrollbarRef;
			const Wrap = ScrollBar.$refs.wrap$;
			if (Wrap) {
				const { scrollTop, clientHeight, scrollHeight } = Wrap;
				// 判断是否滚动到底
				if (scrollTop + (clientHeight+170) >= scrollHeight) {
					if(!this.IsScrollBottom){
						// console.log('滑动到底了!');
						//变换触底状态
						this.IsScrollBottom = true;
						// 在这里执行到底部时的逻辑
					}
				}
			}
		},
		ScrollTop(){
			// this.$refs.ScrollbarRef.setScrollTop(0);

			// console.log(this.$refs.ScrollbarRef.wrap$);

			this.$refs.ScrollbarRef.wrap$.scrollTo({
				top: 0,
				behavior:'smooth' // 实现平滑滚动
			});

		},
		IsScrollBottomInit(){
			this.IsScrollBottom = false;
		},


		ExternalLoginShow(){
			this.$refs.ComponentsTop.LoginShow();
		},
	},
	mounted(){
		Bus.on("ScrollTop",(Value)=>{
			this.$refs.ScrollbarRef.setScrollTop(0);
		});
		Bus.on("onRefreshTopMemberInfo",(Value)=>{
			this.$refs.ComponentsTop.RefreshMemberInfo();

			//判断是否在个人中心页
			if(Value == "Out" && this.$route.path == "/My"){
				Auth.removeToken();
				Auth.removeInfo();
				this.$router.push('/');
			}
		})
	}
}

